<template>
  <v-container-principal>
    <div class="font-weight-black primary--text text-h5 mb-3">
      <v-btn :icon="true" @click="() => this.$router.go(-1)">
        <v-icon class="text-h4" color="black">$prev</v-icon>
      </v-btn>
      Informações da sala
    </div>
    <v-row>
      <v-col md="4" sm="6" cols="12">
        <v-flex class="ml-3">
          <div class="text-h4 font-weight-bold my-4 primary--text">
            {{ nome }}
          </div>

          <div class="text-h5 font-weight-bold mb-4 primary--text">
            {{ localizacao }}
          </div>
          <v-layout class="mt-4">
            <v-flex>
              <div class="text-subtitle-1 font-weight-bold primary--text mt-4">
                Status
              </div>
              <div class="text-h8">{{ status }}</div>
            </v-flex>
          </v-layout>

          <div
            class="text-subtitle-1 font-weight-bold primary--text"
            v-if="responsavel">
            Responsável
          </div>
          <div class="text-h8" v-if="responsavel">{{ responsavel }}</div>
          <div class="text-subtitle-1 font-weight-bold primary--text">
            Número de reservas
          </div>
          <div class="text-h8">{{ reservas.length }}</div>
          <div class="text-subtitle-1 font-weight-bold primary--text">
            Capacidade
          </div>
          <div class="text-h8">{{ capacidade }}</div>
          <div class="text-subtitle-1 font-weight-bold primary--text">
            Computadores
          </div>
          <div class="text-h8">{{ computadores }}</div>

          <div class="text-subtitle-1 font-weight-bold primary--text mt-4">
            Recursos
          </div>
          <div
            class="text-h8"
            v-for="(recurso, index) in recursos"
            :key="index">
            {{ recurso }}
          </div>
          <div class="text-subtitle-1 font-weight-bold primary--text mt-4">
            Observações
          </div>
          <div class="text-h8">{{ observacoes }}</div>
          <v-layout class="mt-4">
            <v-flex>
              <v-btn
                v-if="isResponsavel || isPrefeitura"
                :to="{ name: 'editarSala', params: { id: id } }"
                outlined
                color="primary">
                Editar sala
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout class="mt-4">
            <v-flex>
              <v-btn
                v-if="isAdministrador"
                @click="relatorio"
                outlined
                color="primary">
                Relatório
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-col>

      <v-col md sm cols="12">
        <v-calendario :reservas="reservas"></v-calendario>
      </v-col>
    </v-row>
  </v-container-principal>
</template>

<script>
import { RepositoryFactory } from "../repositories/repositoryFactory"
import VContainerPrincipal from "../components/VContainerPrincipal"
import VCalendario from "./../components/VCalendario.vue"
import dataMixin from "./../mixins/dataMixin"
import { mapGetters } from "vuex"

const salaRepository = RepositoryFactory.get("sala")

export default {
  components: { VContainerPrincipal, VCalendario },
  props: ["id"],
  mixins: [dataMixin],

  data: () => ({
    dialog: false,
    nome: "",
    status: "Disponível para reserva",
    localizacao: "",
    capacidade: "",
    computadores: "",
    observacoes: "",
    responsavel: "",
    responsavelId: "",
    recursos: [],
    reservas: [],

    focus: "",
    type: "month",
    typeToLabel: {
      month: "Mês",
      week: "Semana",
      day: "Dia",
      "4day": "4 dias",
    },
  }),

  mounted() {
    this.initialize()
  },
  computed: {
    isResponsavel() {
      return this.userId === this.responsavelId
    },
    ...mapGetters({
      isAdministrador: ["auth/isAdministrador"],
      isPrefeitura: ["auth/isPrefeitura"],
      userId: ["auth/userId"],
    }),
  },

  methods: {
    initialize() {
      salaRepository.getOne(this.id).then((response) => {
        const sala = response.data.data.attributes
        this.nome = sala.nome
        let andar = sala.andar
        let bloco = sala.bloco.data.attributes.descricao
        this.status = sala.disponivel
          ? "Disponível para reserva"
          : "Indisponível para reserva"
        this.localizacao = bloco + " - Andar " + andar
        this.capacidade = sala.capacidade + " Pessoas"
        this.computadores = sala.computadores
        this.observacoes = sala.observacoes
        this.responsavel = sala.responsavel.data.attributes.username
        this.responsavelId = sala.responsavel.data.id

        this.reservas = sala.reservas.data
          .filter((r) => r.attributes.status === "Confirmado")
          .map((r) =>
            Object.assign(
              r.attributes,
              { responsavel: r.attributes.responsavel.data },
              { id: r.id }
            )
          )

        let ar = sala.arcondicionado
        let projetor = sala.projetor
        let lousa = sala.lousa
        let mesa = sala.mesa

        if (ar) this.recursos.push("Ar-condiconado")

        if (projetor) this.recursos.push("Projetor")

        if (lousa) this.recursos.push("Lousa")

        if (mesa) this.recursos.push("Mesa")
      })
    },
    relatorio() {
      window.print()
    },
  },
}
</script>

<style scoped>
@media print {
  .row {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  .row > div:first-child .text-h4 ~ div {
    display: none;
  }
  .text-h4 {
    margin: 0px !important;
  }
  .row > div:last-child > .v-card {
    border: none;
  }
}
</style>
